/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {GuardsCheckStart, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ReplayableRouterEventsService {
    private routerNavigationStartSubject = new ReplaySubject<NavigationStart>(1);
    private routerNavigationEndSubject = new ReplaySubject<NavigationEnd>(1);
    private routerGuardsCheckStartSubject = new ReplaySubject<GuardsCheckStart>(1);

    constructor(private router: Router) {
        this.router.events
                .pipe(filter((event) => event instanceof NavigationStart), map((event) => event as NavigationStart))
                .subscribe(this.routerNavigationStartSubject);

        this.router.events
                .pipe(filter((event) => event instanceof NavigationEnd), map((event) => event as NavigationEnd))
                .subscribe(this.routerNavigationEndSubject);

        this.router.events
                .pipe(filter((event) => event instanceof GuardsCheckStart), map((event) => event as GuardsCheckStart))
                .subscribe(this.routerGuardsCheckStartSubject);
    }

    get onNavigationStart(): Observable<NavigationStart> {
        return this.routerNavigationStartSubject.asObservable();
    }

    get onNavigationEnd(): Observable<NavigationEnd> {
        return this.routerNavigationEndSubject.asObservable();
    }

    get onGuardsCheckStart(): Observable<GuardsCheckStart> {
        return this.routerGuardsCheckStartSubject.asObservable();
    }
}
